import { QueueState } from '@/scopes/checkout/groups/infrastructure/store/queueStore'

export function isFetchedSelector(state: QueueState) {
  return state.isFetched
}

export function waitingTimeSelector(state: QueueState) {
  return state.waitingTime
}
